/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VoucherType {
  EXPERIENCE = 'experience',
  MONETARY = 'monetary',
}
